import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { auth } from '../firebase';
import { useFirestore } from './useFirestore';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const userRef = useRef(null);
  const { getData } = useFirestore();

  const fetchUserData = useCallback(async (firebaseUser) => {
    if (firebaseUser) {
      try {
        const userData = await getData('users', firebaseUser.uid);
        return { ...firebaseUser, ...userData };
      } catch (error) {
        console.error('Error fetching user data:', error);
        return firebaseUser;
      }
    }
    return null;
  }, [getData]);

  useEffect(() => {
    console.log('UserProvider effect - Setting up auth listener');
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      console.log('Auth state changed:', firebaseUser ? firebaseUser.uid : 'No user');
      const fullUser = await fetchUserData(firebaseUser);
      userRef.current = fullUser;
      setLoading(false);
    });

    return () => {
      console.log('UserProvider effect cleanup - Unsubscribing auth listener');
      unsubscribe();
    };
  }, [fetchUserData]);

  const setUser = useCallback(async (newUser) => {
    const fullUser = await fetchUserData(newUser);
    userRef.current = fullUser;
  }, [fetchUserData]);

  const value = {
    get user() { return userRef.current; },
    loading,
    setUser,
  };

  console.log('UserProvider render - User:', userRef.current?.uid, 'Loading:', loading);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};